module.exports = __webpack_public_path__ + "26f79d32ed08f63a51f12e1cb362ab90.png";